module.exports = __webpack_public_path__ + "media/components/star-rating/static/white/4-8ae5316c302139c4de3e9fd9c9532d32.svg";